import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _fulfillmentSummaryMe, _fulfillmentDetailedM;
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { _ab_color } from "../../../../components/style/colors";
export var RequiredoptionsStyles = {
  required: _ab_color.blue,
  optional: _ab_color.lightBlue,
  inactive: _ab_color.mediumGrey
};
export var requiredStateOptions = ['required', 'optional', 'inactive'];
export var requiredStateOptionsForm = 'required_state_options';
export var ENTITY_LEVELS = {
  intake: 'Intake',
  management_division: 'Management Division',
  program: 'Program',
  school: 'School',
  school_group: 'School Group',
  system: 'System'
};
export var FulfillmentMessageCode = /*#__PURE__*/function (FulfillmentMessageCode) {
  FulfillmentMessageCode["PAYMENT_SUCCESS_BUT_STATUS_FAILED"] = "paymentSuccessButStatusFailed";
  FulfillmentMessageCode["PAYMENT_SYSTEM_DOWN"] = "paymentSystemDown";
  return FulfillmentMessageCode;
}({});
export var strings = {
  fulfillmentSummaryMessages: (_fulfillmentSummaryMe = {}, _defineProperty(_fulfillmentSummaryMe, FulfillmentMessageCode.PAYMENT_SYSTEM_DOWN, 'Payments System Down'), _defineProperty(_fulfillmentSummaryMe, FulfillmentMessageCode.PAYMENT_SUCCESS_BUT_STATUS_FAILED, 'Already Paid - Waiting on Status Update'), _fulfillmentSummaryMe),
  fulfillmentDetailedMessages: (_fulfillmentDetailedM = {}, _defineProperty(_fulfillmentDetailedM, FulfillmentMessageCode.PAYMENT_SYSTEM_DOWN, 'Our payment system is currently down. You will not be able to pay at this time, apologies for the inconvenience. Please refresh the page to try again.'), _defineProperty(_fulfillmentDetailedM, FulfillmentMessageCode.PAYMENT_SUCCESS_BUT_STATUS_FAILED, 'Your payment was successful. Please give the system a few minutes to reflect the requirement status change from “Missing” to “Complete”.'), _fulfillmentDetailedM)
};